import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton, Button, CircularProgress } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import RestoreIcon from '@mui/icons-material/Restore';

const FLOORS = [
  { value: 'ground', label: 'Ground Floor' },
  { value: 'outside', label: 'Outside' },
  { value: 'upstairs', label: 'Upstairs' },
  { value: 'downstairs', label: 'Downstairs' },
];

const FloorSelector = ({ currentFloor, onFloorChange, onSave, onReset, saving, dirty }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 1, borderBottom: '1px solid #ddd' }}>
      <ToggleButtonGroup
        value={currentFloor}
        exclusive
        onChange={(_, val) => val && onFloorChange(val)}
        size="small"
        aria-label="Select floor"
      >
        {FLOORS.map((f) => (
          <ToggleButton key={f.value} value={f.value}>{f.label}</ToggleButton>
        ))}
      </ToggleButtonGroup>

      <Box sx={{ flex: 1 }} />

      <Button
        variant="outlined"
        size="small"
        startIcon={<RestoreIcon />}
        onClick={onReset}
        disabled={!dirty || saving}
      >
        Reset
      </Button>
      <Button
        variant="contained"
        size="small"
        startIcon={saving ? <CircularProgress size={16} /> : <SaveIcon />}
        onClick={onSave}
        disabled={!dirty || saving}
      >
        {saving ? 'Saving…' : 'Save Floor Plan'}
      </Button>
    </Box>
  );
};

export default FloorSelector;
